const firebaseConfig = {
  apiKey: "AIzaSyAFR182CyVQG2i2J2Q9NhOqjGUTRrtuK7g",
  authDomain: "abcd-67e6f.firebaseapp.com",
  projectId: "abcd-67e6f",
  storageBucket: "abcd-67e6f.appspot.com",
  messagingSenderId: "281610669958",
  appId: "1:281610669958:web:15e0fa4298545d0860a607",
};

export default firebaseConfig;
